import React from "react";
import ChartGoal from "charts/ChartGoal";
import ChartLine from "charts/ChartLine";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PdfKPIMetricBlock from "dashboards/PdfKPIMetricBlock";
import MetricFormatter from "dashboards/MetricFormatter";
import PdfKeywordTable from "dashboards/PdfKeywordTable";
import MetricTablePdf from "MetricTablePdf";
import GetFormatter from "dashboards/GetFormatter";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import { camelCase, cloneDeep } from "lodash-es";
import getNegative from "../utils/getNegative";
import getGoalLocked from "utils/getGoalLocked";
import dashboardTableOrder from "../utils/dashboardTableOrder";
const allMetricData = allMetrics();

export default function MonthlySeoSection(props) {
  const goalChartDim = "135x135";
  const lineChartDim = "350x250";
  const goalsPerRow = 5;
  const chartsPerRow = 2;
  const tablesPerRow = 1;
  const section = props.section;
  const cc_data = props.cc_data;
  const dashboard = props.dashboard;
  const metricData = allMetricData["metricData"];
  let date = props.date ? moment(props.date) : moment();
  let month = date.format("MMM");
  let year = date.year();
  function categorize(string) {
    if (string.includes("landingPageGroups")) {
      landingPageCase = string;
    }
    if (string.includes("keywordGroups")) {
      keywordCase = string;
    }
    return string;
  }
  if (section.metrics_data) {
    const renderArray = dashboardTableOrder("seo", Object.keys(section.metrics_data));
    switch (categorize(section.name)) {
      case "goalsAndProjections":
        let seoGoals = props.seo_section.goals;
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header seo-color off-color-bg" style={{ textAlign: "left" }}>
                  SEO Performance
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="seo-color pt-4">Goals & Projections </h3>
            <Row xs={goalsPerRow} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                const current = jsDig([dashboard, metricKey, "raw"], cc_data);
                const goal = parseFloat(jsDig([dashboard, year, month, camelCase(metricKey)], seoGoals));
                const projected = jsDig([dashboard, metricKey, "projected"], cc_data);
                const negative = getNegative(section.name, metricKey, projected - goal, cc_data);
                const goalLocked = getGoalLocked(date, metricKey);
                if (metricKey) {
                  if (jsDig([dashboard, metricKey, "raw"], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey });
                      return (
                        <Col key={index}>
                          <ChartGoal
                            metricName={metricShortened}
                            current={current}
                            goal={goal}
                            projected={projected}
                            formatter={Formatter}
                            negative={negative}
                            goalLocked={goalLocked}
                            pdfDim={goalChartDim}
                          />
                        </Col>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </Row>
          </>
        );
      case "primaryKpiCharts":
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header seo-color off-color-bg" style={{ textAlign: "left" }}>
                  SEO Performance
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="seo-color pt-4">Primary KPI's (charts)</h3>
            <Row sm={chartsPerRow} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  if (jsDig([dashboard, "metrics_by_months", metricKey], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey, tick: true });
                      return (
                        <Col key={index}>
                          <ChartLine
                            metricName={metricShortened}
                            currentYear={jsDig([dashboard, "metrics_by_months", metricKey, 0, "year"], cc_data)}
                            currentYearData={jsDig([dashboard, "metrics_by_months", metricKey, 0, "data"], cc_data)}
                            previousYear={jsDig([dashboard, "metrics_by_months", metricKey, 1, "year"], cc_data)}
                            previousYearData={jsDig([dashboard, "metrics_by_months", metricKey, 1, "data"], cc_data)}
                            tickFormatter={Formatter}
                            pdfDim={lineChartDim}
                          />
                        </Col>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_by_month in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </Row>
          </>
        );
      case "primaryKpiTables":
        let metricTitles = [];
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header seo-color off-color-bg" style={{ textAlign: "left" }}>
                  SEO Performance
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="seo-color pt-4">Primary KPI's (tables)</h3>
            <Row sm={tablesPerRow} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                if (metricKey) {
                  metricTitles.push(metricKey);
                  if (jsDig([dashboard, "metrics_2_years", metricKey], cc_data) == null) {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_2_years in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}

              {[...Array(Math.ceil(metricTitles.length / 4))].map((x, index) => {
                return (
                  <Col className="skinny-table" key={index}>
                    <MetricTablePdf
                      table={jsDig([dashboard, "metrics_2_years"], cc_data)}
                      headerOrder={metricTitles.splice(0, 4)}
                      date={props.date}
                      scrollMessage={false}
                      responsive={false}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        );
      case "backlinks":
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header seo-color off-color-bg" style={{ textAlign: "left" }}>
                  SEO Performance
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="seo-color pt-4">Backlinks</h3>
            <div className="metric-blocks">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  if (jsDig([dashboard, metricKey], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey });
                      const negative = getNegative(section.name, metricKey, jsDig([dashboard, metricKey, "projected_yy"], cc_data));
                      return (
                        <PdfKPIMetricBlock
                          metricName={metricShortened}
                          metric={<Formatter value={jsDig([dashboard, metricKey, "projected"], cc_data)} />}
                          yy={<MetricFormatter.YY value={jsDig([dashboard, metricKey, "projected_yy"], cc_data)} />}
                          negative={negative}
                          key={index}
                        />
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger d-inline-block" key={index}>
                        {metricKey} was not found in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger d-inline-block" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </div>
          </>
        );
      case "keywordRankings":
        let sortedKeywords = jsDig([dashboard, "keyword_rankings"], cc_data);
        switch (props.keyword_sort) {
          case "keyword":
            sortedKeywords.sort((a, b) => {
              if (a.keyword.toLowerCase() < b.keyword.toLowerCase()) return -1;
              if (a.keyword.toLowerCase() > b.keyword.toLowerCase()) return 1;
              return 0;
            });
            break;
          case "prevpos":
            sortedKeywords.sort((a, b) => {
              if (typeof a.start_date_ranking == "string") a.start_date_ranking = parseFloat(a.start_date_ranking);
              if (typeof b.start_date_ranking == "string") b.start_date_ranking = parseFloat(b.start_date_ranking);

              if (a.start_date_ranking == 0) return 1;
              if (b.start_date_ranking == 0) return -1;
              if (a.start_date_ranking < b.start_date_ranking) return -1;
              if (a.start_date_ranking > b.start_date_ranking) return 1;
              return 0;
            });
            break;
          case "currentpos":
            sortedKeywords.sort((a, b) => {
              if (a.end_date_ranking == 0) return 1;
              if (b.end_date_ranking == 0) return -1;
              if (a.end_date_ranking < b.end_date_ranking) return -1;
              if (a.end_date_ranking > b.end_date_ranking) return 1;
              return 0;
            });
            break;
          case "diff":
            sortedKeywords.sort((a, b) => {
              if (a.ranking_difference < b.ranking_difference) return -1;
              if (a.ranking_difference > b.ranking_difference) return 1;
              return 0;
            });
            break;
          case "cpc":
            sortedKeywords.sort((a, b) => {
              if (isNaN(parseFloat(a.cpc))) return -1;
              if (isNaN(parseFloat(b.cpc))) return 1;
              if (parseFloat(a.cpc) < parseFloat(b.cpc)) return -1;
              if (parseFloat(a.cpc) > parseFloat(b.cpc)) return 1;
              return 0;
            });
            break;
          case "volume":
            sortedKeywords.sort((a, b) => {
              if (isNaN(parseFloat(a.volume))) return -1;
              if (isNaN(parseFloat(b.volume))) return 1;
              if (parseFloat(a.volume) < parseFloat(b.volume)) return -1;
              if (parseFloat(a.volume) > parseFloat(b.volume)) return 1;
              return 0;
            });
            break;
          case "difficulty":
            sortedKeywords.sort((a, b) => {
              if (isNaN(parseFloat(a.difficulty))) return -1;
              if (isNaN(parseFloat(b.difficulty))) return 1;
              if (parseFloat(a.difficulty) < parseFloat(b.difficulty)) return -1;
              if (parseFloat(a.difficulty) > parseFloat(b.difficulty)) return 1;
              return 0;
            });
            break;
        }
        if (!props.seo_section.keyword_sort_order_asc) {
          sortedKeywords.reverse();
        }
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header seo-color off-color-bg" style={{ textAlign: "left" }}>
                  SEO Performance
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="seo-color pt-4">Keyword Listings</h3>
            <PdfKeywordTable
              keywords={sortedKeywords.splice(0, renderArray.length)}
              metrics={jsDig(["dashboard_order", dashboard], props.seo_section).find((el) => el.name == "keywordRankings")}
              keyword_sort_order_asc={props.seo_section.keyword_sort_order_asc}
              keyword_sort={props.seo_section.keyword_sort}
              pdf={true}
            />
          </>
        );
      default:
        return <h4 className="text-danger">{section.name} is not a valid section name for this dashboard</h4>;
    }
  }
}
